import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';

import { isAiPanelLinksEnabled } from 'modules/ai/constants/aiPanelLinks';

export const useAiPanelLinksEnabled = (): boolean => {
  const configuration = useSelector(
    (state: State) => state.society?.actualSociety?.configuration
  );

  return isAiPanelLinksEnabled(configuration);
};
